module.exports = __webpack_public_path__ + "static/media/Pennsbury_Manor_Museum_Morrisville_PA_diorama_background_in_finished_in_studio_2.0d99eb77.webp";